import React, { useEffect, useState } from 'react';
import useMediaQuery from '../../hooks/useMediaQuery';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ROLES } from '../../model/roles';
import CustomModal from '../CustomModal/CustomModal';
import { alertService } from '../../services/AlertService';
import imgCard from '../../assets/img/orange-classroom.jpg';
import useCorsi from '../../hooks/useCorsi';
import useClassiUtenti from '../../hooks/useClassiUtenti';
import { Spinner } from 'react-bootstrap';
import { TIPO_CORSO } from '../../model/tipoCorso';

const CorsoDetailsCard = ({ courseData }) => {
  console.log(courseData);
  const isWideScreen = useMediaQuery('(min-width: 1200px)');
  const [isScrolled, setIsScrolled] = useState(false);
  const [requisiti, setRequisiti] = useState([]);
  const navigate = useNavigate();
  const userLoggedIn = useSelector(state => state.user.userData);
  const {modalStateCorsi, loadingStateCorsi, findDocumentiByIdCorso, setModalStateCorsi} = useCorsi();
  const {updateCondizioni, getCondizioni} = useClassiUtenti();

  const [showBonificoModal, setShowBonificoModal] = useState(false);//NEW
  const [showMaggiorazioneCartaModal, setShowMaggiorazioneCartaModal] = useState(false);//NEW
  
  const [showRequestLoginModal, setShowRequestLoginModal] = useState(false);//NEW
  const [showConfirmModal, setShowConfirmModal] = useState(false);//NEW
  const [checkbox1, setCheckbox1] = useState(false);//NEW
  const [checkbox2, setCheckbox2] = useState(false);//NEW
  const [checkbox3, setCheckbox3] = useState(false);//NEW

  const [showConfirmModalFirstAccess, setShowConfirmModalFirstAccess] = useState(false);//NEW
  const [checkboxFA1, setCheckboxFA1] = useState(false);//NEW
  const [checkboxFA2, setCheckboxFA2] = useState(false);//NEW
  const [checkboxFA3, setCheckboxFA3] = useState(false);//NEW
  const [condizioni, setCondizioni] = useState(null);//NEW
  const [isLoadingCondizioni, setIsLoadingCondizioni] = useState(true);//NEW

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 250;
      if (scrolled !== isScrolled) {
        setIsScrolled(scrolled);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isScrolled]);
  
  // const handleCheckout = () => {
  //   navigate(`/checkout`, { state: { courseData } });
  // };
console.log(userLoggedIn);
  const handleConfirm = async () =>  {//NEW
    if (!checkbox1 || !checkbox2 || !checkbox3) {
      alertService.warn("Devi accettare tutte le condizioni!", {autoClose: true});
      return;
    }

    const payload = {
      id_corso: courseData.id_corso,
      id_utente: userLoggedIn.id_utente,
      cond1: checkbox1,
      cond2: checkbox2,
      cond3: checkbox3
    };

    try {
      await updateCondizioni(payload);
      setShowMaggiorazioneCartaModal(true);
      //navigate('/checkout', { state: { courseData } });
    } catch (error) {
      alertService.error("Errore nel salvataggio delle condizioni");
    }
  };

  const handleBonifico = async () =>  {//NEW
    if (!checkbox1 || !checkbox2 || !checkbox3) {
      alertService.warn("Devi accettare tutte le condizioni!", {autoClose: true});
      return;
    }

    const payload = {
      id_corso: courseData.id_corso,
      id_utente: userLoggedIn.id_utente,
      cond1: checkbox1,
      cond2: checkbox2,
      cond3: checkbox3,
      is_bonifico: true,
      prezzo: courseData?.scontoAttivo && courseData?.sconto ? (parseFloat(courseData?.prezzo) - parseFloat(courseData.sconto)).toFixed(2) : parseFloat(courseData?.prezzo),
      causale: courseData?.id_corso + "-" + userLoggedIn?.id_utente
    };

    try {
      await updateCondizioni(payload);
      setShowBonificoModal(true);
    } catch (error) {
      alertService.error("Errore nel salvataggio delle condizioni");
    }
  };

  const handleCheckout = () => {//NEW
    if(userLoggedIn){
      setShowConfirmModal(true);
    }
    else{
      setShowRequestLoginModal(true);
    }
  };

  const handleAccediPage = () => {//NEW
    navigate(`/accedi`);
  }
  
  const handleRegistratiPage = () => {//NEW
    navigate(`/registrati`);
  }

  const handleConfirmFirstAccess = async () =>  {//NEW
    if (!checkboxFA1 || !checkboxFA2 || !checkboxFA3) {
      alertService.warn("Devi accettare tutte le condizioni per iniziare il corso", {autoClose: true});
      return;
    }

    const payload = {
      id_corso: courseData.id_corso,
      id_utente: userLoggedIn.id_utente,
      cond1: checkboxFA1,
      cond2: checkboxFA2,
      cond3: checkboxFA3
    };

    try {
      await updateCondizioni(payload);
      const formatCourseData = {
        ...courseData,
        corso: courseData,
        stato_pagamento: courseData.stato_pagamento
      }
      if (courseData.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA) {
        navigate(`/area-personale/corso`, { state: { classe: formatCourseData } });
      } else {
        navigate(`/area-personale/classe`, { state: { classe: formatCourseData } });
      }
    } catch (error) {
      alertService.error("Errore nel salvataggio delle condizioni");
    }
  };

  const handleFirstAccess = () => {//NEW
    setShowConfirmModalFirstAccess(true);
  };

  const handleAccess = () => {//NEW
    const formatCourseData = {
      ...courseData,
      corso: courseData,
      stato_pagamento: courseData.stato_pagamento
    }
    if (courseData.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA) {
      navigate(`/area-personale/corso`, { state: { classe: formatCourseData } });
    } else {
      navigate(`/area-personale/classe`, { state: { classe: formatCourseData } });
    }
  };

  const handleCloseModal = () => {
    setModalStateCorsi((state) => ({
      ...state,
      showModalDocumentByIdCorso: false,
    }));
  };

  const openRequisitiModal = async () => {
    setModalStateCorsi((state) => ({
      ...state,
      showModalDocumentByIdCorso: true,
    }));

    const fetchRequisiti = await findDocumentiByIdCorso({id_corso: courseData?.id_corso});
    setRequisiti(fetchRequisiti);
  }

  const openWindowPrivacy = () =>{
    window.open("https://www.he-formazione.it/informativa-privacy");
  }

  useEffect(() => {
    const fetchCondizioni = async () => {
      if (
        userLoggedIn?.id_utente &&
        courseData?.id_classe &&
        courseData?.cond === undefined
      ) {
        setIsLoadingCondizioni(true);
        try {
          const payload = {
            id_classe: courseData.id_classe,
            id_utente: userLoggedIn.id_utente,
            id_corso: courseData.id_corso
          };
          var condizioniBool = false;
          const retrievedArray = await getCondizioni(payload);
          if(retrievedArray.length > 0){
            if(retrievedArray[0].cond1 > 0 && retrievedArray[0].cond2 > 0 && retrievedArray[0].cond3 > 0){
              condizioniBool = true;
            }
          }
          setCondizioni(condizioniBool);
        } catch (error) {
          alertService.error("Errore nel recupero delle condizioni: ", error);
        } finally {
          setIsLoadingCondizioni(false);
        }
      } else {
        setIsLoadingCondizioni(false); // non serve fetch, termina caricamento
      }
    };
  
    fetchCondizioni();
  }, [userLoggedIn?.id_utente, courseData?.id_classe, courseData?.cond]);

  const renderRequisitiBody = () => (
    <>
    {
      loadingStateCorsi.isLoadingFindDocumentiByIdCorso ? 
      <div className='m-auto text-center mt-3'>
      <p>Caricamento...</p>
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Caricamento...</span>
      </Spinner>
    </div> :
    <>
    {requisiti?.length === 0 ? (
      <div>
        <span className='d-block'>Non sono presenti requisiti</span>
      </div>
    ) : (
      requisiti?.map((requisito, index) => (
        <div className='mb-3' key={requisito?.id_documento}>
          <span className='d-block'><b>{index + 1}. {requisito?.tipo}</b></span>
          <span className='small'>{requisito?.descrizione}</span>
        </div>
      ))
    )}
    </>
    }
    </>
  )

  const renderPrice = () => {
    if (courseData?.pagato) {
      return <h3><b>Acquistato</b></h3>;
    }

    const prezzo = parseFloat(courseData?.prezzo) || 0;
    const sconto = parseFloat(courseData?.sconto) || 0;

    if (courseData?.scontoAttivo && sconto > 0) {
      return (
        <h3>
          <span className="text-decoration-line-through text-muted me-2">
            <b>{prezzo.toFixed(2)}€</b>
          </span>
          <b className="text-success">
            {(prezzo - sconto).toFixed(2)}€
          </b>
        </h3>
      );
    }

    return <h3><b>{prezzo.toFixed(2)}€</b></h3>;
  };

  const renderButton = () => {
    if (!userLoggedIn) {
      return (
        <button className='btn btn-primary w-100 mt-2 my-4' onClick={handleCheckout}>
          Acquista ora
        </button>
      );
    }
    if (userLoggedIn.role === ROLES.CORSISTA) {
      if (courseData?.pagato || courseData.stato_pagamento === 'Parzialmente_pagato') {//NEW
        if (isLoadingCondizioni) {
          return (
            <button className='btn btn-secondary w-100 mt-2 my-4' disabled>
              Caricamento...
            </button>
          );
        }
      
        // Se courseData.cond è undefined, usa condizioni caricate dinamicamente
        const cond = courseData.cond !== undefined ? courseData : condizioni;
      
        if (!cond || cond.cond1 === 0 || cond.cond2 === 0 || cond.cond3 === 0) {
          return (
            <button className='btn btn-primary w-100 mt-2 my-4' onClick={handleFirstAccess}>
              Accedi al corso
            </button>
          );
        }
        else if(cond || cond.cond1 > 0 || cond.cond2 > 0 || cond.cond3 > 0){
          return (
            <button className='btn btn-primary w-100 mt-2 my-4' onClick={handleAccess}>
              Accedi al corso
            </button>
          );
        }
      
        return (
          <button className='btn btn-primary w-100 mt-2 my-4' disabled>
            Già acquistato
          </button>
        );
      } else if (courseData?.scontoAttivo) {
        return (
          <button className='btn btn-primary w-100 mt-2 my-4' onClick={handleCheckout}>
            Completa Acquisto
          </button>
        );
      } else if (courseData?.numero_massimo_corsisti && TIPO_CORSO.TELEMATICA_ASINCRONA !== courseData.modalita_erogazione && courseData.numero_iscritti >= courseData.numero_massimo_corsisti){
        return (
          <button className='btn btn-danger w-100 mt-2 my-4' disabled>
            Posti Esauriti
          </button>
        );
      }
      else {
        return (
          <button className='btn btn-primary w-100 mt-2 my-4' onClick={handleCheckout}>
            Acquista ora
          </button>
        );
      }
    }
  };

  return (
    <>
    <div style={{ ...(isWideScreen && { maxWidth: "18rem" })}} className={`${isWideScreen && isScrolled ? 'fade-in-top' : ''} ${isWideScreen ? 'card text-dark' : 'text-light'} shadow`}>
      <img src={courseData?.immagine_corso || imgCard} alt='immagine corso' className='card-img-top w-100'/>
      <div className={`card-content ${isWideScreen ? 'p-3' : 'py-3'}`}>
        {renderPrice()}
        <hr/>
        {renderButton()}
        <button onClick={openRequisitiModal} className={`btn ${isWideScreen ? 'text-dark' : 'text-light'} btn-outline-primary w-100 my-2`}>
          Vedi requisiti del corso
        </button>
        <button onClick={openWindowPrivacy} className={`btn ${isWideScreen ? 'text-dark' : 'text-light'} btn-outline-primary w-100 my-2`}>
          Vedi informativa privacy
        </button>
      </div>
    </div>
    
    <CustomModal
      show={modalStateCorsi.showModalDocumentByIdCorso}
      onHide={handleCloseModal}
      headerText="Informazioni requisiti"
      size={"md"}
      hideSaveBtn={true}
      body={renderRequisitiBody()}
      scrollable={true} 
      closeButton={true}
      onUndoChanges={handleCloseModal}
    />
    <CustomModal
      show={showRequestLoginModal}
      onHide={() => setShowRequestLoginModal(false)}
      headerText="ATTENZIONE"
      btnText="Accedi"
      onSave={handleAccediPage}
      secondaryBtnText="Registrati"
      onSecondaryClick={handleRegistratiPage}
      closeButton={true}
      onUndoChanges={() => setShowRequestLoginModal(false)}
      body={
        <div>
          <p>
            Per poter procedere con l'acquisto, devi avere effettuato il Login
          </p>
          <p>
            Se hai già un account nella piattaforma: <div onClick={handleAccediPage}><a href="" target="_self" rel="noopener noreferrer">Accedi</a></div>
          </p>
          <p>
            Se non hai ancora un account: <div onClick={handleRegistratiPage}><a href="" target="_self" rel="noopener noreferrer">Registrati</a></div> 
          </p>
        </div>
      }
    />
    <CustomModal
      show={showConfirmModal}
      onHide={() => setShowConfirmModal(false)}
      headerText="Accetta le condizioni del corso"
      btnText="Paga con carta"
      onSave={handleConfirm}
      secondaryBtnText="Paga con Bonifico"
      onSecondaryClick={handleBonifico}
      closeButton={true}
      onUndoChanges={() => setShowConfirmModal(false)}
      body={
        <div>
          <div className="form-check my-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="checkbox1"
              checked={checkbox1}
              onChange={() => setCheckbox1(!checkbox1)}
            />
            <label className="form-check-label" htmlFor="checkbox1">
              Ho letto e accetto i termini del servizio.
            </label>
          </div>
          <div className="form-check my-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="checkbox2"
              checked={checkbox2}
              onChange={() => setCheckbox2(!checkbox2)}
            />
            <label className="form-check-label" htmlFor="checkbox2">
              Confermo di avere i requisiti richiesti per il corso.
            </label>
          </div>
          <div className="form-check my-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="checkbox3"
              checked={checkbox3}
              onChange={() => setCheckbox3(!checkbox3)}
            />
            <label className="form-check-label" htmlFor="checkbox3">
              Acconsento al <a href="https://www.he-formazione.it/informativa-privacy" target="_blank" rel="noopener noreferrer">Trattamento dei dati personali</a>.
            </label>
          </div>
        </div>
      }
    />
    <CustomModal
      show={showConfirmModalFirstAccess}
      onHide={() => setShowConfirmModalFirstAccess(false)}
      headerText="Accetta le condizioni del corso"
      btnText="Accetta e Inizia il corso"
      onSave={handleConfirmFirstAccess}
      closeButton={true}
      onUndoChanges={() => setShowConfirmModalFirstAccess(false)}
      body={
        <div>
          <div className="form-check my-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="checkboxFA1"
              checked={checkboxFA1}
              onChange={() => setCheckboxFA1(!checkboxFA1)}
            />
            <label className="form-check-label" htmlFor="checkboxFA1">
              Ho letto e accetto i termini del servizio.
            </label>
          </div>
          <div className="form-check my-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="checkboxFA2"
              checked={checkboxFA2}
              onChange={() => setCheckboxFA2(!checkboxFA2)}
            />
            <label className="form-check-label" htmlFor="checkboxFA2">
              Confermo di avere i requisiti richiesti per il corso.
            </label>
          </div>
          <div className="form-check my-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="checkboxFA3"
              checked={checkboxFA3}
              onChange={() => setCheckboxFA3(!checkboxFA3)}
            />
            <label className="form-check-label" htmlFor="checkboxFA3">
              Acconsento al <a href="https://www.he-formazione.it/informativa-privacy" target="_blank" rel="noopener noreferrer">Trattamento dei dati personali</a>.
            </label>
          </div>
        </div>
      }
    />
    <CustomModal
      show={showBonificoModal}
      onHide={() => setShowBonificoModal(false)}
      headerText="Pagamento mediante Bonifico Bancario"
      hideSaveBtn={true}
      closeButton={true}
      onUndoChanges={() => {
        setShowBonificoModal(false);
        setShowConfirmModal(false);
        navigate("/corsi");
      }}
      btnCancelText="Chiudi"
      body={
        <div className="px-2">
          <p>Per completare l'acquisto tramite bonifico bancario, utilizza i seguenti dati:</p>
          <ul className="list-unstyled">
            <li><strong>Beneficiario:</strong> High Educational srls</li>
            <li><strong>IBAN:</strong> IT03Y0895216701000000239777</li>
            {/* <li><strong>Banca:</strong> Nome della banca</li> */}
            <li><strong>Importo:</strong> {courseData?.scontoAttivo && courseData?.sconto ? (parseFloat(courseData?.prezzo) - parseFloat(courseData.sconto)).toFixed(2) : parseFloat(courseData?.prezzo).toFixed(2)} €</li>
            <li><u>Nella causale del bonifico riportate solamente i seguenti numeri e non scrivete niente altro:</u><br></br> <strong>Causale:</strong> {courseData?.id_corso}-{userLoggedIn?.id_utente}</li>
            {/* <li><strong>Causale:</strong> {userLoggedIn?.cognome} {userLoggedIn?.nome} - Corso "{courseData?.denominazione}"</li> */}
            
          </ul>
          <p className="mt-3 text-muted"><small>Una volta effettuato il bonifico, ti invitiamo a inviare la ricevuta a <a href="mailto:amministrazione@he-formazione.it">amministrazione@he-formazione.it</a></small></p>
        </div>
      }
    />
    <CustomModal
      show={showMaggiorazioneCartaModal}
      onHide={() => setShowMaggiorazioneCartaModal(false)}
      headerText="Metodi di pagamento elettronici"
      closeButton={true}
      onUndoChanges={() => setShowMaggiorazioneCartaModal(false)}
      btnCancelText="Annulla"
      btnText="Procedi al pagamento"
      onSave={() => {
        setShowMaggiorazioneCartaModal(false);
        navigate('/checkout', { state: { courseData, maggiorazioneCarta: true } });
      }}
      body={
        <div className="px-2">
          <p>
            Questi metodi di pagamento comportano una <strong>commissione del 5%</strong> sul prezzo del corso.
          </p>
          <ul className="list-unstyled">
            <li>
              <strong>Prezzo corso:</strong>{' '}
              {(courseData?.scontoAttivo && courseData?.sconto
                ? parseFloat(courseData?.prezzo) - parseFloat(courseData?.sconto)
                : parseFloat(courseData?.prezzo)
              ).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
            </li>
            <li>
              <strong>Commissione (5%):</strong>{' '}
              {((
                courseData?.scontoAttivo && courseData?.sconto
                  ? parseFloat(courseData?.prezzo) - parseFloat(courseData?.sconto)
                  : parseFloat(courseData?.prezzo)
              ) * 0.05).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
            </li>
            <li className="mt-2">
              <strong>Totale da pagare:</strong>{' '}
              <span className="text-success fs-5">
                {((
                  courseData?.scontoAttivo && courseData?.sconto
                    ? parseFloat(courseData?.prezzo) - parseFloat(courseData?.sconto)
                    : parseFloat(courseData?.prezzo)
                ) * 1.05).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
              </span>
            </li>
          </ul>
          <p className="mt-3 text-muted">
            <small>
              <strong>Se non desideri pagare alcuna commissione, procedi al pagamento tramite bonifico bancario.</strong>
            </small>
          </p>
        </div>
      }
    />

    </>
  );
};

export default CorsoDetailsCard;
